import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { Table } from '@/main/utils/table';

import { DEPENDENT_TABLES, NAME as name, CRUMB_LABEL_KEY, INVENTORY_PARTS_DATA, RozsahDate } from '../constants';
import { apiProvider } from '../api';

export const dropdownList = {
	Sklad: [],
	Ndpohyb: [],
	Dodavatel: [],
	SmVaria: [],
	VyrobekndOzn: [],
	VyrobekvozOzn: [],
	ZakazkaDruh: [],
	SkladMisto: [],
	DealerKVPSList: [],
	ZbozidruhOzn: [],
	PartsCategory: [],
	UnitOfWork: [],
};

export const edit = {
	SmVariaZkt: [],
	AndOr: false,
	DetailTisk: false,
	DatOd: null as Date | null,
	DatDo: null as Date | null,
	RozsahDate: RozsahDate.casLibObdobi,
	ZakazkaNr: null as number | null,
	SkladOzn: null as number | null,
	SkladMistoId: null as number | null,
	NdpohybPzn: null as number | null,
	DodavatelId: null as number | null,
	OrderByDodavatel: false,
	ZmenaMan: true,
	VyrobekndOzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	RozlVV: false,
	ZakazkaDruh: null as string | null,
	DokladPfx: null as string | null,
	DokladPfxPodretezec: false,
	DokladNrOd: null as number | null,
	DokladNrDo: null as number | null,
	ZakazkaNrDo: null as number | null,
	ZakazkaNrOd: null as number | null,
	ND_NR: null as string | null,
	OldestStockAge: null as number | null,
	ObratkovostDatOd: null as Date | string | null,
	ObratkovostDatDo: null as Date | string | null,
	DealerId: null as string | null,
	LocationId: null as string | null,
	NewStockAge: null as number | null,
	PartCategoryId: null as string | null,
	AvgStockAge: null as number | null,
	PartDescription: null as string | null,
	NoOfUnitsAvaVal: null as number | null,
	LastOrderedDate: null as Date | null,
};

export const localState = {
	accessFlags: 0,
	AndOrList: [] as { Text: string, Value: Boolean }[],
	RozsahDateList: [] as { Text: string, Value: RozsahDate }[],
	EnabledObratkovost: false as boolean,
	InventoryPartsData: new Table(),
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[INVENTORY_PARTS_DATA]: {
			isEditable: true,
			filter() {
				return {
				};
			},
		},
	},
	edit,
	localState,
	extraActions: {},
	extraMutations: {
	},
	extraGetters: {},
	props: {
		mode: null,
	},
});
